"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookLoginButton = FacebookLoginButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const auth_1 = require("@src/types/auth");
function FacebookLoginButton({ type }) {
    react_1.default.useEffect(() => {
        var _a;
        if (typeof document !== 'undefined' && typeof FB !== 'undefined') {
            (_a = FB === null || FB === void 0 ? void 0 : FB.XFBML) === null || _a === void 0 ? void 0 : _a.parse();
        }
    }, []);
    const text = type === auth_1.OAuthType.registration ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "facebook.registration", defaultMessage: "Registrova\u0165 cez Facebook" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "facebook.login", defaultMessage: "Prihl\u00E1si\u0165 cez Facebook" }));
    return ((0, jsx_runtime_1.jsx)("div", { className: "fb-login-button", "data-size": "medium", "data-scope": "public_profile, email", "data-button-type": "login_with", "data-layout": "rounded", "data-auto-logout-link": "false", "data-use-continue-as": "false", "data-width": "", children: text }));
}
